import styles from '../../index.module.scss';
import type { MappingRuleChat } from '../useMappingRuleChat';

// Collects only the two free-text fields a picker cannot supply. Everything
// else — employees, customers, classes, the Any/Blank sentinels, and a
// debit/credit account per cost field — is the Add Rule modal's job.
export default function DetailsCard({ chat }: { chat: MappingRuleChat }) {
	const { details, error } = chat;

	return (
		<div className={styles['action-card']}>
			<div className={styles['action-card__summary']}>Name the rule, then I&apos;ll open the rule builder</div>

			<div className={styles['rule-form']}>
				<label className={styles['rule-form__field']}>
					<span className={styles['rule-form__label']}>Rule name</span>
					<input
						className={styles['rule-form__input']}
						value={details.name}
						placeholder="e.g. Officer salary routing"
						onChange={(e) => chat.patchDetails({ name: e.target.value })}
					/>
					{error && <span className={styles['rule-form__error']}>{error}</span>}
				</label>

				<label className={styles['rule-form__field']}>
					<span className={styles['rule-form__label']}>Description (optional)</span>
					<input
						className={styles['rule-form__input']}
						value={details.description}
						placeholder="What this rule is for"
						onChange={(e) => chat.patchDetails({ description: e.target.value })}
					/>
				</label>

				<span className={styles['rule-form__hint']}>
					Next you&apos;ll pick the employees, customers and classes it matches, and the account each cost field
					should post to — in Settings → Configurations, on the pay period selected there.
				</span>
			</div>

			<div className={styles['action-card__buttons']}>
				<button type="button" className={styles['action-card__confirm']} onClick={chat.handOff}>
					Open rule builder
				</button>
			</div>
		</div>
	);
}
